module.exports = __webpack_public_path__ + "static/media/Add_Button_Negative_Contribution_Fruit.fc32b611.svg";